// TODO - consider generalising this to accept a third-party object and expect to be extended with
//        a third-party specific implementation - this may be overkill but would be more robust
//        if say we decide not to use axios anymore

const DEFAULT_CONFIG = { withCredentials: true };

/**
 *  REST - base object for performing REST API requests
 *
 *  @param {object} api - object making the actual requests
 *  @param {string} baseURL - url to prepend to request urls
 *  @param {object} config  - additional configurations to apply to each request
 *                            in particular we are using axios so see
 *                            https://github.com/mzabriskie/axios for more information about axios instances
 *  @constructor
 */
export function REST(api, baseURL, config = {}) {
    this.api = api.create({
        ...DEFAULT_CONFIG,
        ...config,
        baseURL,
    });
}

REST.prototype.get = function(route, params = {}, options = {}) {
    return this.api.get(route, { params }, options);
};

REST.prototype.post = function(route, params = {}, options = {}) {
    return this.api.post(route, params, options);
};

REST.prototype.delete = function(route, params = {}, options = {}) {
    return this.api.delete(route, {
        ...options,
        data: params,
    });
};

REST.prototype.put = function(route, params = {}, options = {}) {
    return this.api.put(route, params, options);
};

REST.prototype.patch = function(route, params = {}, options = {}) {
    return this.api.patch(route, params, options);
};
